import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './ListEmptyState.scss';

interface Props {
  icon: any;
  title: string;
  description: React.ReactNode;
  className?: string;
}

export function ListEmptyState({ icon, title, description, className = '' }: Props) {
  return (
    <div className={`listEmptyState ${className}`.trim()} role="status">
      <div className="listEmptyState__icon" aria-hidden="true">
        <FontAwesomeIcon icon={icon} />
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}

